/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Allocation_Form_Price_Per_CycleInputs */

const en_admin_allocation_form_price_per_cycle = /** @type {(inputs: Admin_Allocation_Form_Price_Per_CycleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Price`)
};

const de_admin_allocation_form_price_per_cycle = /** @type {(inputs: Admin_Allocation_Form_Price_Per_CycleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preis`)
};

const es_admin_allocation_form_price_per_cycle = /** @type {(inputs: Admin_Allocation_Form_Price_Per_CycleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Precio`)
};

const fr_admin_allocation_form_price_per_cycle = /** @type {(inputs: Admin_Allocation_Form_Price_Per_CycleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prix`)
};

const nl_admin_allocation_form_price_per_cycle = /** @type {(inputs: Admin_Allocation_Form_Price_Per_CycleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prijs`)
};

/** @type {(inputs: Admin_Allocation_Form_Price_Per_CycleInputs) => LocalizedString} */
const it_admin_allocation_form_price_per_cycle = en_admin_allocation_form_price_per_cycle;

/** @type {(inputs: Admin_Allocation_Form_Price_Per_CycleInputs) => LocalizedString} */
const pt_br2_admin_allocation_form_price_per_cycle = en_admin_allocation_form_price_per_cycle;

/** @type {(inputs: Admin_Allocation_Form_Price_Per_CycleInputs) => LocalizedString} */
const pl_admin_allocation_form_price_per_cycle = en_admin_allocation_form_price_per_cycle;

/** @type {(inputs: Admin_Allocation_Form_Price_Per_CycleInputs) => LocalizedString} */
const hu_admin_allocation_form_price_per_cycle = en_admin_allocation_form_price_per_cycle;

/** @type {(inputs: Admin_Allocation_Form_Price_Per_CycleInputs) => LocalizedString} */
const ro_admin_allocation_form_price_per_cycle = en_admin_allocation_form_price_per_cycle;

/**
* | output |
* | --- |
* | "Price" |
*
* @param {Admin_Allocation_Form_Price_Per_CycleInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_allocation_form_price_per_cycle = /** @type {((inputs?: Admin_Allocation_Form_Price_Per_CycleInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Allocation_Form_Price_Per_CycleInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_allocation_form_price_per_cycle(inputs)
	if (locale === "de") return de_admin_allocation_form_price_per_cycle(inputs)
	if (locale === "es") return es_admin_allocation_form_price_per_cycle(inputs)
	if (locale === "fr") return fr_admin_allocation_form_price_per_cycle(inputs)
	if (locale === "nl") return nl_admin_allocation_form_price_per_cycle(inputs)
	if (locale === "it") return it_admin_allocation_form_price_per_cycle(inputs)
	if (locale === "pt-BR") return pt_br2_admin_allocation_form_price_per_cycle(inputs)
	if (locale === "pl") return pl_admin_allocation_form_price_per_cycle(inputs)
	if (locale === "hu") return hu_admin_allocation_form_price_per_cycle(inputs)
	return ro_admin_allocation_form_price_per_cycle(inputs)
});
export { admin_allocation_form_price_per_cycle as "admin.allocation_form.price_per_cycle" }